export const runPlaybackAttempt = (
  attempt: () => void | Promise<void>,
  rejected: () => void,
): void => {
  try {
    void Promise.resolve(attempt()).catch(rejected);
  } catch {
    rejected();
  }
};
